export default "__VITE_ASSET__27MQ_4ZF__"